<script setup lang="ts">
import { AkIcon } from '@ankorstore/design-system';
import { ItemIconConfig } from '@client/modules/discovery/ui/filters/types';

defineProps<{
  iconConfig: ItemIconConfig;
}>();
</script>

<template>
  <div
    class="filter-icon"
    :class="`ds-bg-${iconConfig.background} `"
    data-testid="filterIcon"
  >
    <AkIcon
      :symbol="iconConfig.symbol"
      :class="`ds-text-${iconConfig.text}`"
      class="filter-icon__icon"
      data-testid="filterIconSymbol"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter-icon {
  @apply ds-rounded-full ds-w-5 ds-h-5 ds-flex ds-items-center ds-justify-center;
  &__icon {
    @apply ds-text-[16px] ds-leading-[16px];
  }
}
</style>
